import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import LeaChatbot from "@/components/LeaChatbot";
import CookieConsent from "@/components/CookieConsent";
import AccessibilityWidget from "@/components/AccessibilityWidget";
import HomePage from "@/pages/HomePage";
import CityPage from "@/pages/CityPage";
import CountryPage from "@/pages/CountryPage";
import SPACountryPage from "@/pages/SPACountryPage";
import GuardianCountryPage from "@/pages/GuardianCountryPage";
import CityServicePage from "@/pages/CityServicePage";
import GuidePage from "@/pages/GuidePage";
import { BlogPage, BlogPostPage } from "@/pages/BlogPage";
import { AllCitiesPage, AllCountriesPage } from "@/pages/AllPages";
import ComparePage from "@/pages/ComparePage";
import AdminPage from "@/pages/AdminPage";

function App() {
  return (
    <div className="App min-h-screen flex flex-col" id="main-wrapper">
      <BrowserRouter>
        <Navbar />
        <main className="flex-1" id="main-content" role="main">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/city/:slug" element={<CityPage />} />
            <Route path="/estate-planning/:slug" element={<CityServicePage />} />
            <Route path="/property/:slug" element={<CityServicePage />} />
            <Route path="/notary/:slug" element={<CityServicePage />} />
            <Route path="/inheritance/:slug" element={<CityServicePage />} />
            <Route path="/ofw/:slug" element={<CountryPage />} />
            <Route path="/spa/:slug" element={<SPACountryPage />} />
            <Route path="/guardian/:slug" element={<GuardianCountryPage />} />
            <Route path="/guides/:slug" element={<GuidePage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/all-cities" element={<AllCitiesPage />} />
            <Route path="/all-countries" element={<AllCountriesPage />} />
            <Route path="/compare" element={<ComparePage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </main>
        <Footer />
        <LeaChatbot />
        <CookieConsent />
        <AccessibilityWidget />
      </BrowserRouter>
    </div>
  );
}

export default App;
